import { useQuery } from '@tanstack/react-query';
import { PageHeader, StatCard } from '@boothiva/ui';
import { Building2, CheckCircle2, Clock, ShieldAlert } from 'lucide-react';
import { listTenants } from '../customers/api';

export function DashboardPage() {
  // Milestone simplification: derive status counts from the returned tenant list until
  // Phase 5 adds the server-aggregated /platform/dashboard endpoint.
  const tenants = useQuery({ queryKey: ['platform-tenants', 'dashboard'], queryFn: () => listTenants({ page: 1, pageSize: 100 }) });
  const count = (status: string) => tenants.data?.items.filter((item) => item.status === status).length ?? 0;
  return <>
    <PageHeader title="Platform overview" description="A live view of registered Boothiva customers." />
    <div className="bv-grid bv-section">
      <StatCard label="Total tenants" icon={<Building2 aria-hidden="true" size={20} />} href="/customers" value={String(tenants.data?.totalCount ?? 0)} loading={tenants.isLoading} />
      <StatCard label="Active" icon={<CheckCircle2 aria-hidden="true" size={20} />} href="/customers?status=Active" value={String(count('Active'))} loading={tenants.isLoading} />
      <StatCard label="Pending verification" icon={<Clock aria-hidden="true" size={20} />} href="/customers?status=PendingVerification" value={String(count('PendingVerification'))} loading={tenants.isLoading} />
      <StatCard label="Suspended" icon={<ShieldAlert aria-hidden="true" size={20} />} href="/customers?status=Suspended" value={String(count('Suspended'))} loading={tenants.isLoading} />
    </div>
    <p className="bv-muted bv-admin-note">Status counts are derived from the current tenant list for this milestone; server-side dashboard aggregation is planned for Phase 5.</p>
  </>;
}
